import axios from "axios";

axios.defaults.baseURL = "https://api.itk-rus.ru/"
export default axios
